import * as types from './action_types';
import UserTacksService from '../../services/user_tacks';
import TackMapper from '../utils/tack_mapper';

export const done = () => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.USER_DONE_TACKS_RETRIEVING });
      const finishedTacksData = await UserTacksService.done();
      const finishedTacks = []
      for (let finishedTack of finishedTacksData) {
        finishedTacks.push(TackMapper.map(finishedTack));
      }
      dispatch({ type: types.USER_DONE_TACKS_RETRIEVED, finishedTacks });
    } catch(error) {
      dispatch({ type: types.USER_TACKS_RETRIEVAL_ERROR, error });
    }
  }
}

export const notDone = () => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.USER_NOT_DONE_TACKS_RETRIEVING });
      const unFinishedTacksData = await UserTacksService.notDone();
      const unFinishedTacks = []
      for (let unFinishedTack of unFinishedTacksData) {
        unFinishedTacks.push(TackMapper.map(unFinishedTack));
      }
      dispatch({ type: types.USER_NOT_DONE_TACKS_RETRIEVED, unFinishedTacks });
    } catch(error) {
      dispatch({ type: types.USER_TACKS_RETRIEVAL_ERROR, error });
    }
  }
}

export const queued = () => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.USER_QUEUED_TACKS_RETRIEVING });
      const queuedTacksData = await UserTacksService.queue();
      const queuedTacks = []
      for (let queuedTack of queuedTacksData) {
        queuedTacks.push(TackMapper.map(queuedTack));
      }
      dispatch({ type: types.USER_QUEUED_TACKS_RETRIEVED, queuedTacks });
    } catch(error) {
      dispatch({ type: types.USER_TACKS_RETRIEVAL_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/user_tacks/actions.js